import { useNavigate } from "@tanstack/react-router";
import { Loader } from "lucide-react";
import type { JSX } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AppConfig } from "@/common/appConfig";
import { V3LoadingScreen } from "@/components/ui/v3/loading-screen";
import { useVisitList } from "@/lib/visit-queries";

/**
 * /launch?action=latest-visit: opens the most recent visit, or the New visit
 * sheet when there is none (or the list cannot be read).
 */
export const LaunchPage = (): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { files, ready, error } = useVisitList();
  const latest = files[0]?.public_id;

  useEffect(() => {
    if (ready && latest != null) {
      void navigate({
        to: "/visits/$visitPublicId",
        params: { visitPublicId: String(latest) },
        replace: true,
      });
    } else if (ready || error) {
      void navigate({
        to: "/visits",
        search: { openNewVisit: true },
        replace: true,
      });
    }
  }, [ready, error, latest, navigate]);

  if (AppConfig.enableAppRedesign)
    return <V3LoadingScreen label={t("emrLaunch.opening")} />;

  return (
    <div
      className="flex h-screen supports-[height:100dvh]:h-dvh flex-col items-center justify-center gap-3 text-muted-foreground"
      role="status"
    >
      <Loader aria-hidden="true" className="size-6 animate-spin" />
      <p className="text-sm">{t("emrLaunch.opening")}</p>
    </div>
  );
};
